export default __webpack_public_path__ + "static/media/tokennomics1.884b5ffe.png";